<template>
  <w-sliding-popup type="setting" ref="slidingPopup" title="학습 데이터 자원 그룹 저장" width="1100px" :default-content="false">
    <div slot="content" class="body-content-no-scroll" style="height:100%;">
      <el-scrollbar style="width:300px; height: 100%; float:left;">
        <w-predict-target-obj-tree class="mr-r30" style="width:100%" ref="targetObjTree" @select-node="selectNode" :showCheckBoxFlag="true" :force-select-leaf="true"></w-predict-target-obj-tree>
      </el-scrollbar>
      <div style="float: right; width: calc(100% - 330px);">
        <span class="title-bar title-h4 mr-r10">학습 데이터 설정 목록</span>
        <el-table-wrapper style="width:100%; height:calc(100% - 16px;)" :fit-height="true" :data="selectionRscLearnData" :columns="rscLearnTableColumn" ref="rscLearnTable" :pagination="false" :show-search-tool="false" :show-custom-header="true">
        </el-table-wrapper>
      </div>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="learnDataGroupSave">저장</el-button>
      <el-button size="large" @click="closePopup">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isNil } from 'lodash';
import msgUtil from '@/utils/message';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import WPredictTargetObjTree from '@/views/settings/operation/BasicInfoSettings/EventPredictSetting/components/PredictTargetObjTree';
import EventPredictSettingsAPI from '@/api/settings/common/event-predict-settings';

export default {
  name: 'WRscLearnDataGroupSavePopup',
  components: {
    WPredictTargetObjTree,
  },
  props: {
    selectionRscLearnData: {
      type: Array,
      default: () => [],
    },
    selectObjtypeId: {
      type: String,
    },
  },
  data() {
    return {
      targetObjParams: {},
      rscLearnTableColumn: [
        {
          prop: 'rsctypeName',
          label: '자원 구분',
          remoteProp: 'rt.rsctype_name',
          sortable: true,
          searchable: false,
        },
        {
          prop: 'rscName',
          label: '자원',
          remoteProp: 'r.rsc_name',
          sortable: true,
          searchable: false,
        },
        {
          prop: 'predictDatetime',
          label: '예측일',
          searchType: 'date',
          formatter: this.getDateFormatter,
          sortable: true,
          searchable: false,
        },
        {
          prop: 'learnDataSetLabel',
          label: '학습 데이터',
          remoteProp: 'pcld.learn_data_set_label',
          searchable: false,
        },
      ],
    };
  },
  methods: {
    open() {
      this.$refs.slidingPopup.open();
      this.loadPredictTargetTreeData();
    },
    /**
     * 예측 자원 설정된 관리대상 트리를 조회한다.
     * @author yelim
     * @return {[type]}
     */
    loadPredictTargetTreeData() {
      this.$nextTick(() => {
        this.$refs.targetObjTree.loadData({ objDefineId: this.selectObjtypeId });
      });
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * 예측 자원 설정된 관리대상 트리 클릭 이벤트 핸들러
     * @author yelim
     * @param  {[type]} node [description]
     * @return {[type]}      [description]
     */
    selectNode(node) {
      const params = {};
      if (!isNil(node.obj)) {
        params.objId = node.objId;
      } else if (!isNil(node.objDefineId)) {
        params.objDefineId = node.objDefineId;
      }
      this.targetObjParams = params;
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      } else if (isNil(value) && isNil(column) && !isNil(row)) {
        return getDateToString(row);
      }
      return EMPTY_TEXT;
    },
    /**
     * 학습 데이터 그룹 저장을 수행한다.
     * @author yelim
     * @return {[type]}
     */
    learnDataGroupSave() {
      const checkedNodeList = this.$refs.targetObjTree.$refs.targetObjTree.getCheckedNodes();
      const params = {};
      const objIdList = [];
      checkedNodeList.forEach((item) => {
        if (!isNil(item.obj)) {
          objIdList.push(item.obj.objId);
        }
      });
      params.objIdList = objIdList;
      params.learnRscInfo = this.selectionRscLearnData;
      EventPredictSettingsAPI.setRscLearnDataSetting(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '자원 학습 데이터 설정 그룹', true));
          this.$emit('reload');
          this.closePopup();
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '자원 학습 데이터 설정 그룹', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '자원 학습 데이터 설정 그룹', false));
        throw new Error(e);
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/EventPredictSetting/CustomLearnDataSetting/popup/RscLearnDataGroupSavePopup.vue